import { MappableModel } from './mappable-model'

export class PersonaEmailAddress extends MappableModel {
  public address: string
  public alerts: boolean
  public enabled: boolean
  public id: number
  public is_primary: boolean
  public label: string
}
